import ClientJS from 'clientjs';
import init from 'MMT-UI/init';
import { getAndUpdateDvid } from 'MMT-UI/helpers/client/dvid';
const os = new ClientJS().getOS();

export const setCookie = (cookieName, cookieValue, cookieExdays, domain) => {
  var d = new Date();
  d.setTime(d.getTime() + cookieExdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cookieName + '=' + cookieValue + ';' + expires + `;path=/; domain=.${domain}`;
};

export const getCookie = cname => {
  if (typeof document !== 'undefined') {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
  return '';
};

export const getExpire = () => {
  const now = new Date();
  let time = now.getTime();
  time += 354 * 24 * 60 * 60 * 1000; /* one year cookie */
  now.setTime(time);
  return now;
};

export const deleteCookie = name => {
  const parts = window.location.host.split('.');
  const domain = parts[1];
  const type = parts[2];
  document.cookie =
    name + `=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.${window.location.host}`;
  document.cookie =
    name + `=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=${window.location.host}`;
  document.cookie =
    name + `=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.${domain}.${type}`; // For Test environments
};

const createMCID = () => {
  init();
  const dvid = getAndUpdateDvid();
  return dvid;
};

const getMCID = () => {
  const dvid = getAndUpdateDvid() || null;
  if (dvid) return dvid;
  else {
    return createMCID();
  }
};

export const getBaseCBHeaders = () => {
  return {
    os: os.name,
    'device-id': getMCID(),
  };
};
